module.exports = __webpack_public_path__ + "img/product-brakeshoes-slider.6fde0d29.jpg";